module.exports = __webpack_public_path__ + "img/error.70d429a1.png";